var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-event"},[_c('div',{class:['insight-event-home team', {
      win: Number(_vm.event.homeScoreWholeMatch) > Number(_vm.event.awayScoreWholeMatch)
    }]},[_vm._v("\n    "+_vm._s(_vm.event.homeCompetitor)+"\n  ")]),_vm._v(" "),_c('div',{class:['insight-event-away team', {
      win: Number(_vm.event.homeScoreWholeMatch) < Number(_vm.event.awayScoreWholeMatch)
    }]},[_vm._v("\n    "+_vm._s(_vm.event.awayCompetitor)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }